import {selectOrderTrackings} from 'app/features/orders/redux/order/orderSlice'
import {useMemo} from 'react'
import {useSelector} from 'react-redux'
import {RootState} from 'setup'
import groupBy from 'lodash/groupBy'
import values from 'lodash/values'
import maxBy from 'lodash/maxBy'
import filter from 'lodash/filter'
import mapValues from 'lodash/mapValues'
import TrackingItem from './TrackingItem'
import {appTypes} from 'app/enums/enumerations'

const OrderTracking: React.FC = () => {
  const trackings = useSelector<RootState, any[]>(selectOrderTrackings)

  const orderTrackings = useMemo(() => {
    if (trackings) {
      const filterList = filter(
        trackings,
        ({message, appType}) =>
          (!!message?.errors && appType === appTypes.FORT_SYSTEM) ||
          appType === appTypes.WINE_SHIPPING
      )
      const grouped = groupBy(filterList, 'appType')
      const latestObjects = mapValues(grouped, (group) =>
        maxBy(group, (obj) => new Date(obj.createdAt))
      )
      return values(latestObjects)
    }
    return []
  }, [trackings])

  if (orderTrackings && orderTrackings.length === 0) {
    return null
  }

  return (
    <>
      {orderTrackings && orderTrackings.map((app, index) => <TrackingItem {...app} key={index} />)}
    </>
  )
}

export default OrderTracking
